import React from 'react';
import PropTypes from 'prop-types';
import BlacklistQuickAction from '../utils/BlacklistQuickAction';

const IpColumnField = ({ record = {} }) => {
    const alreadyBlacklisted = record.blacklistedip === true || record.filtereddoubles === true || record.suspectedcrawler === true;
    return (
        <BlacklistQuickAction
            value={record.user_ip}
            entityLabel="IP"
            paramName="ip"
            alreadyBlacklisted={alreadyBlacklisted}
            blacklistEndpoint="admin/doblacklistip"
            whitelistEndpoint="admin/dowhitelistip"
            durationNote="wordt 6 maanden geblacklist."
        />
    );
};

IpColumnField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
};

export default IpColumnField;



// WEBPACK FOOTER //
// ./src/siteclicks/IpColumnField.js